export type ImageGenerate = {
  imageUrl: string;
  success: boolean;
  prompt: string;
  aspectRatio: string;
  userStats: {
    imagesGeneratedThisWeek: number;
    maxImagesPerWeek: number;
    remainingImages: number;
    weekStartDate: string;
    daysUntilReset: number;
  };
};

export interface ImageInput {
  prompt: string;
  aspectRatio?: AspectRatioEnum;
  lessonId?: number;
}

export enum AspectRatioEnum {
  SQUARE = '1:1',
  LANDSCAPE = '16:9',
  PORTRAIT = '9:16',
  STANDARD = '4:3',
  PORTRAIT_STANDARD = '3:4',
}
